<template>
  <div class="header_container header-none-menu">
    <div class="header">
      <div class="toggle-menu">
        <div class="icon"></div>
        <div class="logo-responsive">
          <router-link :to="pathDefault">
            <img
              v-bind:src="m_event !== null ? m_event.logo_img : logoImg"
              alt
            />
          </router-link>
        </div>
      </div>

      <div class="redLine"></div>
      <div class="btn_group btn_group_fix">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn_item btn_item_dropdown"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              v-if="dataLanguage.length > 1"
            >
              {{ langTitle || select }}
              <v-icon class="icon-language">{{ arrowDown }}</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in dataLanguage"
              :key="index"
              v-on:click="changeLanguage(item.lang_code, item.lang_name)"
            >
              <v-list-item-title>{{ item.lang_name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div class="mainLogo">
      <div class="logo">
        <router-link :to="pathDefault">
          <img v-bind:src="m_event !== null ? m_event.logo_img : logoImg" alt />
        </router-link>
        <router-link :to="pathDefault" class="home-link">
          <h2>
            {{ m_event !== null && m_event.event_name }}
          </h2></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  mdiBell,
  mdiFacebook,
  mdiEarth,
  mdiEmail,
  mdiChevronDown,
  mdiMenu
} from '@mdi/js';

import { Trans } from '@/plugins/translation.js';
import { mapGetters } from 'vuex';
import {
  LANG_CODE_JAPANESE_LOWERCASE,
  LANG_CODE_JAPANESE_UPPERCASE,
  LANG_CODE_VIETNAMESE_LOWERCASE,
  LANG_CODE_VIETNAMESE_UPPERCASE
} from '@/common/constants';

export default {
  data: () => ({
    bellIcon: mdiBell,
    fbIcon: mdiFacebook,
    webIcon: mdiEarth,
    mailIcon: mdiEmail,
    menuIcon: mdiMenu,
    arrowDown: mdiChevronDown,
    title: 'TOP',
    menu: true,
    bannerImage: '',
    currentRoute: 'home',
    select: '',

    isActive: false,

    drawer: null,
    banner: false,

    logoImg: `/image/logoMain.svg`
  }),
  watch: {
    '$route.name': function () {
      this.currentRoute = this.$route.name;
      this.initHeader();
    }
  },
  methods: {
    getLanguageFromLS() {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      return objFromLS.sekisho_lang || null;
    },

    async setLanguageFromLS(_lang) {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      const newObj = {
        ...objFromLS,
        sekisho_lang: _lang
      };

      await localStorage.setItem(keyStore, JSON.stringify(newObj));
    },

    initHeader() {
      switch (this.$route.name) {
        case 'home':
          this.title = 'TOP';
          this.bannerImage = 'top-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'companyDetail':
          this.title = 'menu.company-detail';
          this.bannerImage = 'company-detail-page';
          this.menu = false;
          this.banner = true;
          break;
        case 'listCompany':
          this.title = 'menu.list-company';
          this.bannerImage = 'list-company-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'mailBox':
          this.title = 'menu.recruitment-letter';
          this.bannerImage = 'mail-box-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'applications':
          this.title = 'menu.recruitment-status';
          this.bannerImage = 'applications-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'profile':
          this.title = 'menu.basic-infomation';
          this.bannerImage = '';
          // this.bannerImage = "profile-page";
          this.menu = true;
          this.banner = false;
          break;
        case 'entrance':
          this.title = 'menu.application-info';
          // this.bannerImage = "entrance-page";
          this.bannerImage = '';
          this.menu = true;
          this.banner = false;
          break;
        case 'mycode':
          this.title = 'menu.my-code';
          this.bannerImage = '';
          // this.bannerImage = "my-code-page";
          this.menu = true;
          this.banner = false;
          break;
      }
    },

    async setSelectedLanguage(lang_code) {
      const langActive = this.dataLanguageFromServer.filter(
        (lang) => lang.lang_code === lang_code
      );

      await this.changeLanguage(lang_code, this.select);

      Trans.changeLanguage(lang_code);

      this.select = langActive.length > 0 ? langActive[0].lang_name : '';
    },

    toggleMenu() {
      this.isActive = !this.isActive;
    },

    changeLanguage(_lang, title) {
      this.setLanguageFromLS(_lang);
      Trans.changeLanguage(_lang);
      this.select = title;
      this.$store.dispatch('changeLanguage', { lang: _lang });
    },

    checkCurrentLanguage() {
      const lang = this.getLanguageFromLS();
      if (lang !== null) {
        this.setSelectedLanguage(lang);
      } else {
        this.setLangFromEventDefault();
      }
    },

    setLangFromEventDefault() {
      if (this.m_event !== null && this.m_event.default_lang !== null) {
        this.setSelectedLanguage(this.m_event.default_lang);
      }
    },

    checkLangExisted(lang) {
      if (
        lang === LANG_CODE_VIETNAMESE_UPPERCASE ||
        lang === LANG_CODE_VIETNAMESE_LOWERCASE ||
        lang === LANG_CODE_JAPANESE_UPPERCASE ||
        lang === LANG_CODE_JAPANESE_LOWERCASE
      ) {
        this.setSelectedLanguage(lang);
      }
    },

    setlangFromStorage() {
      const sekisho_lang = this.getLanguageFromLS();

      if (sekisho_lang !== null) {
        this.setSelectedLanguage(sekisho_lang);
      }
    }
  },

  mounted() {
    this.currentRoute = this.$route.name;

    this.checkCurrentLanguage();

    const languageInStorage = this.getLanguageFromLS();

    const { lang } = this.$route.query;

    if (languageInStorage !== null && typeof lang === 'undefined') {
      this.setlangFromStorage();
    } else if (languageInStorage !== null && typeof lang !== 'undefined') {
      this.checkLangExisted(lang);
    } else if (languageInStorage == null && typeof lang !== 'undefined') {
      this.checkLangExisted(lang);
    } else if (languageInStorage === null && lang === 'undefined') {
      this.setLangFromEventDefault();
    }

    if (this.$route.name === 'company-preview') {
      const { query } = this.$route;
      if (query) {
        const { language } = query;
        if (language) {
          this.setSelectedLanguage(language);
        }
      }
    }

    this.initHeader();
  },

  computed: {
    ...mapGetters({
      dataLang: 'getLang',
      dataLanguageFromServe: 'getDataLanguage',
      getContractId: 'getContractId',
      getEventCode: 'getEventCode'
    })
  }
};
</script>

<style lang="scss">
@import '../style/devices.scss';

.header_container {
  border-bottom: 1px solid lightgray;
  // padding-bottom: 10px;
  .header {
    background: url('../assets/image/header.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position-x: right;
    height: 45px;
    padding-right: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;

    .redLine {
      background: #e8320d;
      height: 10px;
      width: 100%;
      align-self: flex-start;
    }

    .btn_group {
      color: #fff;
      width: 500px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .btn_item {
        height: 25px;

        &:not(:last-child) {
          padding: 0 10px;
        }

        &:last-child {
          margin: 0 10px;
        }

        .v-btn__content {
          border-bottom: 1.5px solid transparent !important;
          transition: 0.3s all;
          padding-bottom: 2px;
          padding-left: 2px;
          padding-right: 2px;

          &:hover {
            border-color: #ffffff !important;
          }
        }
      }

      .btn_item_dropdown {
        background-color: transparent !important;
        border-color: #fff !important;

        box-shadow: none;
        height: 25px;

        .icon-language {
          margin-left: 15px;
        }
      }

      .icon {
        width: 12px;
        height: 12px;
        border: 1px solid #ffffff;
      }

      .slash {
        border-right: 1px solid #fff;
        border-radius: 0;
      }

      .v-input__slot {
        padding: 0 20px;
        margin: 0;

        input {
          color: #fff;
        }

        &::before {
          border: none;
        }

        svg {
          fill: #fff;
        }
      }
    }
  }

  .v-btn .v-btn--contained .theme--dark .v-size--default {
    display: none;
  }

  .mainLogo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 60px;
    padding-right: 60px;
    margin-top: -30px;

    .logo {
      min-height: 90px;
      display: flex;
      align-items: center;

      img {
        width: 90px;
        margin-right: 22px;
        // margin-top: -10px;
      }
      h2 {
        max-width: 82vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        //padding-top: 10px;
      }
    }

    .logo:not(:has(img)) h2 {
      padding: 15px 0 5px 50px;
      max-width: 85vw;
    }

    .icons {
      display: flex;
      align-items: center;
      margin-top: 21px;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background: #4b4948;
      }

      div {
        margin-right: 24px;
      }

      .iconFB {
        margin-right: 21px;
      }
    }
  }
  .mainLogo:not(:has(img)) {
    height: 90px;
  }
}

.header {
  .toggle-menu {
    position: absolute;
    left: -100px;
    top: 20px;
    //display: flex;
    justify-content: flex-start;
    align-items: center;
    display: none;

    .icon {
      margin-right: 20px;
    }

    .logo-responsive {
      height: 30px;

      img {
        height: 30px;
      }
    }
  }
}

.btn_group_fix {
  top: 2px !important;
  right: 20px !important;
}

.header-none-menu {
  .logo {
    margin-top: 0 !important;
  }
}
</style>
